/**
 * Shared accessibility helpers for viva form controls (WCAG 3.3.1, 4.1.2).
 */
export function getAriaDescribedBy(isInvalid: boolean, errorNoteId?: string): string | null {
  if (!isInvalid || !errorNoteId) {
    return null;
  }
  return errorNoteId;
}

export function getAriaInvalidAttr(isInvalid: boolean): 'true' | null {
  return isInvalid ? 'true' : null;
}
